<template>
  <div class="sales-report__stats-box">
    <div class="css-grid sales-report__header">
      <div class="sales-report__header-name">Purchases Per Audiologist</div>
    </div>

    <div class="sales-report__body">
      <ChartCustom :chart-settings="chartConfig" :dimensions="chartConfig.size"></ChartCustom>
    </div>
  </div>
</template>

<script>
  import * as d3 from 'd3';
  import { mapGetters } from 'vuex';
  import ChartCustom from '../../general/ChartCustom.vue';

  export default {
    name: 'StatsRevenuePerEmployee',
    components: {
      ChartCustom,
    },
    computed: {
      ...mapGetters('purchaseActivityFlash', ['contents']),
      stats() {
        return this.contents.statsNational;
      },
      formattedData() {
        return {
          'category': ['Active'],
          'Practice': [this.stats.revenue_per_audiologist],
          'National Average': [this.stats.nat_revenue_per_audiologist]
        };
      },
      minValue() {
        const val1 = parseFloat(this.stats.revenue_per_audiologist);
        const val2 = parseFloat(this.stats.nat_revenue_per_audiologist);
        // const val2 = 11.2;
        const percentResult = 0.92 * (val1 < val2 ? val1 : val2);
        return percentResult > 15 ? percentResult : undefined;
      },
      chartConfig() {
        return {
          size: {
            height: 140,
          },
          data: {
            json: this.formattedData,
            type: 'bar',
            x: 'category',
            labels: {
              format: d3.format("$,.0f")
            },
            colors: {
              'Practice': '#824a9e',
              'National Average': '#39c2c9'
            },
          },
          axis: {
            x: {
              type: 'category',
              show: true,
              tick: {
                rotate: 90
              },
              height: 130
            },
            y: {
              show: false,
              min: this.minValue,
              tick: {
                format: d3.format("$,.0f"),
              },
            },
            rotated: true
          },
          bar: {
            space: 0.25,
            width: 50
          },
          legend: { show: true, position: 'bottom' },
          tooltip: {
            show: false
          }
        };
      },
    },
  };
</script>
